module.exports = __webpack_public_path__ + "img/icon_quick_blog.0637c3c2.svg";